// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestCircle {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }

    private _circle?: vf.gui.Circle;
    private _circle1?: vf.gui.Circle;
    private _circle2?: vf.gui.Circle;
    private _buttonList: vf.gui.Label[] = [];
    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        /** 绘制 */
        const circle = this._circle = new vf.gui.Circle();
        circle.interactabled = true;
        // circle.style.left = 150;
        // circle.style.top = 120;
        circle.anchorX = 0.1;
        circle.anchorY = 0.1;
        circle.color = 0xffffff;
        circle.lineColor = 0xff00cc;
        circle.lineWidth = 1;
        circle.radius = 20;
        circle.width = 50;
        circle.height = 50;
        uiStage.addChild(circle);

        /** 透明 */
        const circle1 = this._circle1 = new vf.gui.Circle();
        circle1.style.left = 150;
        circle1.style.top = 350;
        circle1.color = 0xff00ff;
        circle1.lineColor = 0xff00cc;
        circle1.lineWidth = 10;
        circle1.width = 50;
        circle1.height = 50;
        uiStage.addChild(circle1);

        /** 绘制半圆 */
        const circle2 = this._circle2 = new vf.gui.Circle();
        circle2.style.left = 350;
        circle2.style.top = 350;
        //circle1.color = undefined;
        circle2.lineColor = 0xffffcc;
        circle2.lineWidth = 2;
        circle2.startAngle = 0;
        circle2.endAngle = 0;
        circle2.width = 50;
        circle2.height = 50;
        uiStage.addChild(circle2);


        circle.on(vf.gui.Interaction.TouchMouseEvent.onUp, this.onClick, this);
        circle.on(vf.gui.Interaction.TouchMouseEvent.onDown, this.onClick, this);
        circle.on(vf.gui.Interaction.TouchMouseEvent.onPress, this.onClick, this);
        circle.on(vf.gui.Interaction.TouchMouseEvent.onMove, this.onClick, this);
        circle.on(vf.gui.Interaction.TouchMouseEvent.onHover, this.onClick, this);
        circle.on(vf.gui.Interaction.TouchMouseEvent.onClick, this.onClick, this);


        this.getButton('设置/取消width', () => {

            if (circle.width != 200) {

                circle.width = 200;
            } else {
                circle.width = 100;
            }
        }, uiStage, 650, 0);


        this.getButton('设置/取消lineColor', () => {

            if (circle.lineColor != 0xffffff) {

                circle.lineColor = 0xffffff;
            } else {
                circle.lineColor = 0xff00cc;
            }
        }, uiStage, 650, 0);


        this.getButton('设置/取消lineWidth', () => {

            if (circle.lineWidth != 10) {

                circle.lineWidth = 10;
            } else {
                circle.lineWidth = 1;
            }
        }, uiStage, 650, 0);



        this.getButton('设置/取消color', () => {

            if (circle.color != 0xff00cc) {

                circle.color = 0xff00cc;
            } else {
                circle.color = 0xffffff;
            }
        }, uiStage, 650, 0);



        this.getButton('设置/取消anchorX', () => {

            if (circle.anchorX != 0.3) {

                circle.anchorX = 0.3;
            } else {
                circle.anchorX = 0.1;
            }
        }, uiStage, 650, 0);






        this.getButton('设置/取消anchorY', () => {

            if (circle.anchorY != 0.3) {

                circle.anchorY = 0.3;
            } else {
                circle.anchorY = 0.1;
            }
        }, uiStage, 650, 0);



        let ticker: vf.Ticker;
        this.getButton('设置/取消startAngle', () => {

            if (circle2.startAngle != 45) {

                circle2.startAngle = 45;
            } else {
                circle2.startAngle = 0;
            }

            if(ticker === undefined){
                ticker = vf.gui.TickerShared.add(() => {
                    if (circle2.endAngle >= 360) {
                        circle2.startAngle++;
                    } else {
                        circle2.endAngle++;
                    }
                    if (circle2.endAngle >= 360 && circle2.startAngle >= 360) {
                        circle2.startAngle = 0;
                        circle2.endAngle = 0;
                    }
                })
            }

        }, uiStage, 650, 0);


        this.getButton('设置/取消endAngle', () => {

            if (circle2.endAngle != 45) {

                circle2.endAngle = 45;
            } else {
                circle2.endAngle = 0;
            }

            if(ticker === undefined){
                ticker = vf.gui.TickerShared.add(() => {
                    if (circle2.endAngle >= 360) {
                        circle2.startAngle++;
                    } else {
                        circle2.endAngle++;
                    }
                    if (circle2.endAngle >= 360 && circle2.startAngle >= 360) {
                        circle2.startAngle = 0;
                        circle2.endAngle = 0;
                    }
                })
            }
        }, uiStage, 650, 0);


        this.getButton('设置/取消 fillColor', () => {
            if (circle.style.fillGradientType !== 1) {
                circle.style.fillGradientType = 1
                circle.style.fillGradientStops = [0, 0.5, 0.5, 1] // 渐变分布
                circle.style.fillColor = [[255, 0, 0, 1], [0, 255, 0, 1], [0, 0, 255, 1], [0, 0, 0, 1]];
            } else {
                circle.style.fillGradientType = 0
                circle.style.fillGradientStops = [0, 0.5, 0.5, 1] // 渐变分布
                circle.style.fillColor = [[255, 0, 0, 1], [0, 255, 0, 1], [0, 0, 255, 1], [0, 0, 0, 1]];
            }

        }, uiStage, 650, 0);

    }


    private onClick(e: vf.gui.Interaction.InteractionEvent) {
        console.log(e.type);
    }


    private posY = 15;
    private getButton(title: string, clickFun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 30;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, clickFun);
        target.addChild(button);
        this.posY = this.posY + 30 + y;
        this._buttonList.push(button);
        return button;
    }
    private onRelease() {
        if (this._circle) {
            this._circle.removeAllListeners();
            this._circle.parent && this._circle.parent.removeChild(this._circle);
            this._circle.release();
            this._circle = undefined;
        }
        if (this._circle1) {
            this._circle1.removeAllListeners();
            this._circle1.parent && this._circle1.parent.removeChild(this._circle1);
            this._circle1.release();
            this._circle1 = undefined;
        }
        if (this._circle2) {
            this._circle2.removeAllListeners();
            this._circle2.parent && this._circle2.parent.removeChild(this._circle2);
            this._circle2.release();
            this._circle2 = undefined;
        }

        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }




}

